// extracted by mini-css-extract-plugin
export default {"list":"RecurrentesLista_list__Xo9Sy"};